import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { RadioDropdown } from '@saucelabs/sl-component-form';
import { isEqual as _isEqual, reduce as _reduce } from 'lodash';


const flattenTunnels = (tunnels) => _reduce(
  tunnels,
  (acc, dataCenter) => [...acc, ...dataCenter],
  [],
);

class RealDevicesConfiguratorTunnel extends Component {
  shouldComponentUpdate(nextProps) {
    const { activeDataCenterId, tunnels } = this.props;
    const currentTunnelIdentifiers = flattenTunnels(tunnels)
      .map((tunnel) => tunnel.tunnelIdentifier).sort();
    const nextTunnelIdentifiers = flattenTunnels(nextProps.tunnels)
      .map((tunnel) => tunnel.tunnelIdentifier).sort();

    return activeDataCenterId !== nextProps.activeDataCenterId ||
      !_isEqual(currentTunnelIdentifiers, nextTunnelIdentifiers);
  }

  render() {
    const { activeDataCenterId, onChange, tunnels } = this.props;
    const etiquette = 'Select tunnel';
    const emptyTunnel = {
      text: etiquette,
      value: '-1',
    };

    const prepareItem = (item) => ({
      key: item.id,
      text: `${item.tunnelIdentifier} (${item.dataCenterId})`,
      value: item.tunnelIdentifier,
      disabled: item.dataCenterId !== activeDataCenterId,
    });
    const options = flattenTunnels(tunnels).map(prepareItem);

    if (options.length) {
      options.unshift(emptyTunnel);
    }

    return (
      <Field
        component={RadioDropdown}
        disabled={!options.length}
        etiquette={options.length ? etiquette : 'No Active Tunnels'}
        isInputForm
        label="Sauce Connect Proxy"
        name="tunnelIdentifier"
        normalize={(value) => (value === emptyTunnel.value ? null : value)}
        onChange={onChange}
        options={options}
        showOptional
        type="input"
      />
    );
  }
}

RealDevicesConfiguratorTunnel.propTypes = {
  activeDataCenterId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  tunnels: PropTypes.object.isRequired,
};

RealDevicesConfiguratorTunnel.defaultProps = {
  activeDataCenterId: null,
};

export default RealDevicesConfiguratorTunnel;
